const { default: axios } = require("axios");

const genreFetchRequest = () => {
  return {
    type: "GENRE_FETCH_REQUEST",
  };
};

const genreFetchSuccess = (genre) => {
  return {
    type: "GENRE_FETCH_SUCCESS",
    payload: genre,
  };
};

const genreFetchFailure = (error) => {
  return {
    type: "GENRE_FETCH_FAILURE",
    payload: error,
  };
};

const genreFetch = () => {
  return (dispatch) => {
    dispatch(genreFetchRequest());
    axios({
      method: "GET",
      url: "/genres",
    })
      .then((response) => {
        const genre = response.data;
        dispatch(genreFetchSuccess(genre));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(genreFetchFailure(errorMsg));
      });
  };
};

export default genreFetch;
